/* unplugin-vue-components disabled */import __unplugin_components_0 from 'E:/new-admin/3.0/ruoyi-vue3-cli/src/components/SvgIcon/index.vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6d7cf234"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "register"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "后台管理系统", -1));
const _hoisted_3 = {
  class: "register-code"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  style: {
    "float": "right"
  }
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-register-footer"
}, [/*#__PURE__*/_createElementVNode("span", null, "Copyright © 2018-2022 ruoyi.vip All Rights Reserved.")], -1));
import { ElMessageBox } from "element-plus";
import { getCodeImg, register } from "@/api/login";
export default {
  __name: 'register',
  setup(__props) {
    const router = useRouter();
    const {
      proxy
    } = getCurrentInstance();
    const registerForm = ref({
      username: "",
      password: "",
      confirmPassword: "",
      code: "",
      uuid: ""
    });
    const equalToPassword = (rule, value, callback) => {
      if (registerForm.value.password !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    const registerRules = {
      username: [{
        required: true,
        trigger: "blur",
        message: "请输入您的账号"
      }, {
        min: 2,
        max: 20,
        message: "用户账号长度必须介于 2 和 20 之间",
        trigger: "blur"
      }],
      password: [{
        required: true,
        trigger: "blur",
        message: "请输入您的密码"
      }, {
        min: 5,
        max: 20,
        message: "用户密码长度必须介于 5 和 20 之间",
        trigger: "blur"
      }],
      confirmPassword: [{
        required: true,
        trigger: "blur",
        message: "请再次输入您的密码"
      }, {
        required: true,
        validator: equalToPassword,
        trigger: "blur"
      }],
      code: [{
        required: true,
        trigger: "change",
        message: "请输入验证码"
      }]
    };
    const codeUrl = ref("");
    const loading = ref(false);
    const captchaOnOff = ref(true);
    function handleRegister() {
      proxy.$refs.registerRef.validate(valid => {
        if (valid) {
          loading.value = true;
          register(registerForm.value).then(res => {
            const username = registerForm.value.username;
            ElMessageBox.alert("<font color='red'>恭喜你，您的账号 " + username + " 注册成功！</font>", "系统提示", {
              dangerouslyUseHTMLString: true,
              type: "success"
            }).then(() => {
              router.push("/login");
            }).catch(() => {});
          }).catch(() => {
            loading.value = false;
            if (captchaOnOff) {
              getCode();
            }
          });
        }
      });
    }
    function getCode() {
      getCodeImg().then(res => {
        captchaOnOff.value = res.captchaOnOff === undefined ? true : res.captchaOnOff;
        if (captchaOnOff.value) {
          codeUrl.value = "data:image/gif;base64," + res.img;
          registerForm.value.uuid = res.uuid;
        }
      });
    }
    getCode();
    return (_ctx, _cache) => {
      const _component_svg_icon = __unplugin_components_0;
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        ref: "registerRef",
        model: _unref(registerForm),
        rules: registerRules,
        class: "register-form"
      }, {
        default: _withCtx(() => [_hoisted_2, _createVNode(_component_el_form_item, {
          prop: "username"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(registerForm).username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(registerForm).username = $event),
            type: "text",
            size: "large",
            "auto-complete": "off",
            placeholder: "账号"
          }, {
            prefix: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "user",
              class: "el-input__icon input-icon"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "password"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(registerForm).password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(registerForm).password = $event),
            type: "password",
            size: "large",
            "auto-complete": "off",
            placeholder: "密码",
            onKeyup: _withKeys(handleRegister, ["enter"])
          }, {
            prefix: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "password",
              class: "el-input__icon input-icon"
            })]),
            _: 1
          }, 8, ["modelValue", "onKeyup"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "confirmPassword"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(registerForm).confirmPassword,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(registerForm).confirmPassword = $event),
            type: "password",
            size: "large",
            "auto-complete": "off",
            placeholder: "确认密码",
            onKeyup: _withKeys(handleRegister, ["enter"])
          }, {
            prefix: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "password",
              class: "el-input__icon input-icon"
            })]),
            _: 1
          }, 8, ["modelValue", "onKeyup"])]),
          _: 1
        }), _unref(captchaOnOff) ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          prop: "code"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            size: "large",
            modelValue: _unref(registerForm).code,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(registerForm).code = $event),
            "auto-complete": "off",
            placeholder: "验证码",
            style: {
              "width": "63%"
            },
            onKeyup: _withKeys(handleRegister, ["enter"])
          }, {
            prefix: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "validCode",
              class: "el-input__icon input-icon"
            })]),
            _: 1
          }, 8, ["modelValue", "onKeyup"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
            src: _unref(codeUrl),
            onClick: getCode,
            class: "register-code-img"
          }, null, 8, _hoisted_4)])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            loading: _unref(loading),
            size: "large",
            type: "primary",
            style: {
              "width": "100%"
            },
            onClick: _withModifiers(handleRegister, ["prevent"])
          }, {
            default: _withCtx(() => [!_unref(loading) ? (_openBlock(), _createElementBlock("span", _hoisted_5, "注 册")) : (_openBlock(), _createElementBlock("span", _hoisted_6, "注 册 中..."))]),
            _: 1
          }, 8, ["loading", "onClick"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_router_link, {
            class: "link-type",
            to: '/login'
          }, {
            default: _withCtx(() => [_createTextVNode("使用已有账户登录")]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _hoisted_8]);
    };
  }
};